module.exports = __webpack_public_path__ + "media/images/flags/LK-ff334b52b6faa4fb8e9493cf3dbf52c1.svg";